import React from 'react';

import * as S from './styles';
import { FieldsWrapper } from '../../components';
import HeadTitle from '../../components/HeadTitle';
import { SpecialistList, UnitFilter } from '../../models/Specialist';
import { SpecialistCard } from './components/SpecialistCard';
import { handleSpecialtiesWithExpertises } from '../../utils/specialist-utils';

export type SpecialistsTemplateProps = {
  specialists?: SpecialistList[];
  goBack?: () => void;
  handleSelectedSpecialist?: (prop: SpecialistList) => void;
  childBelowTitle?: React.ReactNode;
};

export function SpecialistsTemplate({
  specialists,
  goBack,
  handleSelectedSpecialist,
  childBelowTitle
}: SpecialistsTemplateProps) {
  const onSelectSpecialist = (specialist: SpecialistList) => {
    handleSelectedSpecialist?.(specialist);
  };

  return (
    <S.Container>
      <FieldsWrapper>
        <HeadTitle title="Selecione um especialista" goBack={goBack} />
        <>
          {childBelowTitle}
          {specialists?.map(item => (
            <SpecialistCard
              key={item.id}
              title={item.name}
              subtitle={handleSpecialtiesWithExpertises(item.specialties)}
              icon={item.profile_picture}
              onClick={() => onSelectSpecialist(item)}
              active={item.active}
            />
          ))}
        </>
      </FieldsWrapper>
      {/* <FooterWrapper>
        <S.ButtonWrapper>
          <Button title="Continuar" type="button" onClick={onSubmit} />
        </S.ButtonWrapper>
      </FooterWrapper> */}
    </S.Container>
  );
}
